import EmbedInputBarMinimized from "./EmbedInputBarMinimized"
import EmbedInputBarMaximized from "./EmbedInputBarMaximized"
import { ApolloCache, DefaultContext, FetchResult, MutationFunctionOptions } from "@apollo/client"
import { IProviderChangeStatusConversationOutput, IProviderChangeStatusConversationInput, IProviderReassignConversationOutput, IProviderReassignConversationInput } from "../../../graphql/types/mutations/conversation"

const EmbedInputBar: React.FC<{
  onDiscard: () => void
  isReplying: boolean
  onReply: () => void
  onNote: () => void
  onTags: () => void
  isNoting: boolean
  conversationId: string
  isPatientConvo: boolean
  reassignConversation: (options?: MutationFunctionOptions<IProviderReassignConversationOutput, IProviderReassignConversationInput, DefaultContext, ApolloCache<any>> | undefined) => Promise<FetchResult<IProviderReassignConversationOutput>>
  changeStatusConversation: (options?: MutationFunctionOptions<IProviderChangeStatusConversationOutput, IProviderChangeStatusConversationInput, DefaultContext, ApolloCache<any>> | undefined) => Promise<FetchResult<IProviderChangeStatusConversationOutput>>
  sendReplyHandler: (html: string, assignTo: number, status: string, attachments?: Array<{
    fileName: string,
    mimeType: string,
    data: string,
    size: number,
  }> | null) => void
}> = ({ onReply,
  isReplying,
  onNote,
  isNoting,
  sendReplyHandler,
  onTags,
  isPatientConvo,
  onDiscard,
  conversationId,
  reassignConversation,
  changeStatusConversation }) => {

    if (!isNoting && !isReplying) {
      return (
        <EmbedInputBarMinimized onNote={onNote} onReply={onReply} onTags={onTags} 
        conversationId={conversationId} 
        reassignConversation={reassignConversation}
          changeStatusConversation={changeStatusConversation} />
      )
    } else {
      return (
        <EmbedInputBarMaximized
        isPatientConvo={isPatientConvo}
         isNote={isNoting} sendReplyHandler={sendReplyHandler} onDiscard={onDiscard} onTags={onTags}
        conversationId={conversationId} 
        reassignConversation={reassignConversation}
          changeStatusConversation={changeStatusConversation} />
      )
    }
  }

export default EmbedInputBar